import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import logoWhite from '@/assets/logo-hostvsl-white.png';

interface SharePageLayoutProps {
  children: React.ReactNode;
}

export function SharePageLayout({ children }: SharePageLayoutProps) {
  useLanguage();
  return (
    <div className="min-h-screen flex flex-col relative" style={{ backgroundColor: '#1f6bff' }}>
      {/* Header com logo */}
      <header className="relative z-10 py-6 px-4 sm:py-8">
        <div className="max-w-[680px] mx-auto">
          <img
            src={logoWhite}
            alt={translateInterfaceText("HostVSL")}
            className="h-6 sm:h-7 mx-auto"
          />
        </div>
      </header>

      {/* Main Content - Modal centralizado */}
      <main className="relative z-10 flex-1 flex items-start sm:items-center justify-center px-4 py-6 sm:py-8">
        <div className="w-[min(92vw,640px)] 2xl:max-w-[680px] max-h-[80vh] overflow-y-auto scrollbar-thin">
          {children}
        </div>
      </main>

      {/* Footer discreto */}
      <footer className="relative z-10 py-4 px-4 text-center">
        <p className="text-xs text-white/60">
          {translateInterfaceText("Powered by HostVSL")}</p>
      </footer>
    </div>
  );
}
